import React from 'react';
import { PRIVACY_DOCUMENT, PRIVACY_WAITLIST_ADDENDUM } from '../legal/privacy';
import LegalDocumentPage from '../marketing/pages/LegalDocumentPage';

/**
 * /privacy — the patient-facing privacy notice. The text lives in
 * src/legal/privacy.ts (a verbatim port of the controlled document) and the
 * shell in src/marketing/pages/LegalDocumentPage.tsx. This route keeps its
 * path because the consent gate, enrolment, the analytics banner and the
 * waitlist form (/privacy#waitlist) all link to it.
 */
const PrivacyPage: React.FC = () => <LegalDocumentPage document={PRIVACY_DOCUMENT} addendum={PRIVACY_WAITLIST_ADDENDUM} />;

export default PrivacyPage;
